(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function post(url, payload) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  function announce(cart) {

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
    );
  }

  async function addVariant(variantId, quantity) {
    var response = await post('cart/add.js', {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: bundledSections(),
    });

    if (!response.ok) throw await response.json();

    var added = await response.json();

    var cart = await (await fetch(root + 'cart.js')).json();
    cart.sections = added.sections;
    announce(cart);
    return cart;
  }

  async function changeLine(lineKey, quantity) {
    var response = await post('cart/change.js', {
      id: lineKey,
      quantity: quantity,
      sections: bundledSections(),
    });

    if (!response.ok) throw await response.json();

    var cart = await response.json();
    announce(cart);
    return cart;
  }

  async function addAccessory(button) {
    if (button.hasAttribute('aria-busy')) return;

    var variantId = button.getAttribute('data-variant-id');

    button.setAttribute('aria-busy', 'true');

    try {
      await addVariant(variantId, 1);
    } catch (error) {
      console.error('[lkl-cart] accessory add failed', error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function closeAllSelects(except) {
    document.querySelectorAll('[data-lkl-select]').forEach(function (select) {
      if (select === except) return;
      var button = select.querySelector('[data-lkl-select-button]');
      var list = select.querySelector('[data-lkl-select-list]');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    });
  }

  function openSelect(select) {
    var button = select.querySelector('[data-lkl-select-button]');
    var list = select.querySelector('[data-lkl-select-list]');
    if (!button || !list) return;

    closeAllSelects(select);

    list.hidden = false;
    list.style.minWidth = '';
    list.style.maxWidth = '';

    var rect = button.getBoundingClientRect();
    var host = select.closest('cart-drawer, cart-notification-drawer, .lkl-cart') || document.documentElement;
    var hostRect = host.getBoundingClientRect();

    var available = Math.max(160, hostRect.width - 32);
    list.style.minWidth = rect.width + 'px';
    list.style.maxWidth = available + 'px';

    var width = list.getBoundingClientRect().width;
    var left = Math.min(rect.left, hostRect.right - width - 8);
    left = Math.max(left, hostRect.left + 8);

    var spaceBelow = window.innerHeight - rect.bottom;
    var height = list.getBoundingClientRect().height;
    var top = spaceBelow >= height + 8 ? rect.bottom + 4 : Math.max(8, rect.top - height - 4);

    list.style.left = Math.round(left) + 'px';
    list.style.top = Math.round(top) + 'px';

    button.setAttribute('aria-expanded', 'true');
  }

  function chooseOption(option) {
    var select = option.closest('[data-lkl-select]');
    var card = option.closest('.lkl-cart-acc-card');
    if (!select || option.getAttribute('aria-disabled') === 'true') return;

    select.querySelectorAll('[role="option"]').forEach(function (item) {
      item.setAttribute('aria-selected', item === option ? 'true' : 'false');
    });

    var label = select.querySelector('[data-lkl-select-label]');
    if (label) label.textContent = option.textContent.trim();

    if (select.hasAttribute('data-lkl-select-native')) {
      var native = select.parentNode && select.parentNode.querySelector('select');
      if (native && native.value !== option.dataset.value) {
        native.value = option.dataset.value;
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (card) {
      var price = card.querySelector('[data-lkl-acc-price]');
      var addButton = card.querySelector('[data-lkl-add]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (addButton) addButton.setAttribute('data-variant-id', option.dataset.value);
    }

    closeAllSelects();
  }

  function enhanceNativeSelect(native, modifier) {
    if (!native || native.dataset.lklEnhanced) return;
    native.dataset.lklEnhanced = 'true';

    var root = document.createElement('div');
    root.className = 'lkl-cart-select' + (modifier ? ' lkl-cart-select--' + modifier : '');
    root.setAttribute('data-lkl-select', '');
    root.setAttribute('data-lkl-select-native', '');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lkl-cart-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('data-lkl-select-button', '');

    var label = document.createElement('span');
    label.setAttribute('data-lkl-select-label', '');
    label.textContent = native.options[native.selectedIndex] ? native.options[native.selectedIndex].text : '';
    button.appendChild(label);

    button.insertAdjacentHTML(
      'beforeend',
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="M4 6.5 8 10.5l4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );

    var list = document.createElement('ul');
    list.className = 'lkl-cart-select__list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('data-lkl-select-list', '');
    list.hidden = true;

    var realOptions = Array.prototype.filter.call(native.options, function (opt) {
      return opt.value !== '';
    });

    if (!native.value && realOptions.length) {
      native.value = realOptions[0].value;
      native.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (native.options[native.selectedIndex]) {
      label.textContent = native.options[native.selectedIndex].text;
    }

    realOptions.forEach(function (opt) {
      var li = document.createElement('li');
      li.className = 'lkl-cart-select__option';
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = opt.value;
      li.setAttribute('aria-selected', opt.value === native.value ? 'true' : 'false');
      li.textContent = opt.text;
      list.appendChild(li);
    });

    root.appendChild(button);
    root.appendChild(list);
    native.parentNode.insertBefore(root, native);
    native.classList.add('lkl-cart-select__native');

    native.addEventListener('change', function () {
      var current = native.options[native.selectedIndex];
      if (!current) return;
      label.textContent = current.text;
      list.querySelectorAll('[role="option"]').forEach(function (item) {
        item.setAttribute('aria-selected', item.dataset.value === native.value ? 'true' : 'false');
      });
    });
  }

  function initEstimatorSelects(scope) {
    (scope || document).querySelectorAll('[data-lkl-estimator]').forEach(function (wrap) {

      enhanceNativeSelect(wrap.querySelector('country-selector select'), 'country');
    });
  }

  function carouselStep(track) {
    var card = track.querySelector('.lkl-cart-acc-card');
    if (!card) return track.clientWidth;

    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function syncCarousel(carousel) {
    var track = carousel.querySelector('[data-lkl-carousel-track]');
    var prev = carousel.querySelector('[data-lkl-carousel-prev]');
    var next = carousel.querySelector('[data-lkl-carousel-next]');
    var progress = carousel.querySelector('[data-lkl-carousel-progress]');
    if (!track) return;

    var scrollable = Math.max(0, track.scrollWidth - track.clientWidth);

    var measurable = track.clientWidth > 0;
    var canScroll = measurable && scrollable > 2;

    var ratio = canScroll ? track.scrollLeft / scrollable : 0;
    var visible = canScroll ? track.clientWidth / track.scrollWidth : 1;

    if (progress) {
      progress.style.width = Math.max(visible, 0.1) * 100 + '%';
      progress.style.transform = 'translateX(' + ratio * (1 / Math.max(visible, 0.1) - 1) * 100 + '%)';
    }

    if (prev) prev.disabled = !canScroll || track.scrollLeft <= 1;
    if (next) next.disabled = !canScroll || track.scrollLeft >= scrollable - 1;

    carousel.classList.toggle('is-static', !canScroll);
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-lkl-carousel]').forEach(function (carousel) {
      if (carousel.dataset.lklCarouselReady) return;
      carousel.dataset.lklCarouselReady = 'true';

      var track = carousel.querySelector('[data-lkl-carousel-track]');
      if (!track) return;

      track.addEventListener('scroll', function () {
        syncCarousel(carousel);
      }, { passive: true });

      carousel.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-lkl-carousel-prev]');
        var next = event.target.closest('[data-lkl-carousel-next]');
        if (!prev && !next) return;

        track.scrollBy({ left: (prev ? -1 : 1) * carouselStep(track), behavior: 'smooth' });
      });

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function () {
          syncCarousel(carousel);
        }).observe(track);
      }

      syncCarousel(carousel);
    });
  }

  var POPUP_SELECTOR = '.lkl-cart-popup-drawer';

  function keepOnlyAddedItems(items) {
    var popup = document.querySelector(POPUP_SELECTOR);
    var group = popup && popup.querySelector('[data-lkl-added-group]');
    if (!group || !items || !items.length) return;

    var keys = items.map(function (item) { return String(item.key); });

    Array.prototype.forEach.call(group.querySelectorAll('[data-line-key]'), function (card) {
      if (keys.indexOf(String(card.getAttribute('data-line-key'))) === -1) card.remove();
    });

    if (!group.querySelector('[data-line-key]')) group.remove();
  }

  document.addEventListener('variant:add', function (event) {

    requestAnimationFrame(function () {
      keepOnlyAddedItems(event.detail && event.detail.items);
      initCarousels();
    });
  });

  function accessoryItems() {
    var items = [];
    var seen = {};

    function push(variantId, isGift) {
      var id = parseInt(variantId, 10);
      if (!id || seen[id]) return;
      seen[id] = true;

      var item = { id: id, quantity: 1 };

      if (isGift) item.properties = { _lkl_gift: 'true' };

      items.push(item);
    }

    document.querySelectorAll('.pa-checkbox:checked').forEach(function (input) {
      push(input.value, input.getAttribute('data-offer-type') === 'FREE');
    });

    document.querySelectorAll('.campaign-bundle__radio:checked[data-variant-ids]').forEach(function (bundle) {
      bundle.getAttribute('data-variant-ids').split(',').forEach(function (variantId) {
        push(variantId, true);
      });
    });

    return items;
  }

  function formField(form, name) {
    var field = form.elements.namedItem(name);
    if (!field) return null;
    return field.value !== undefined ? field : field[0] || null;
  }

  function lineItemProperties(form) {
    var props = {};

    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      if (input.value === '') return;

      var name = input.getAttribute('name').slice('properties['.length, -1);
      props[name] = input.value;
    });

    return props;
  }

  async function addProductWithAccessories(form, extras, goToCheckout) {
    var idField = formField(form, 'id');
    if (!idField || !idField.value) return;

    var quantityField = formField(form, 'quantity');
    var planField = formField(form, 'selling_plan');

    var main = {
      id: Number(idField.value),
      quantity: quantityField ? parseInt(quantityField.value, 10) || 1 : 1,
    };

    var props = lineItemProperties(form);
    if (Object.keys(props).length) main.properties = props;
    if (planField && planField.value) main.selling_plan = Number(planField.value);

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );

    var buttons = Array.prototype.filter.call(form.elements, function (el) {
      return el.type === 'submit';
    });
    buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); });

    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [main].concat(extras),
          sections: sections,
          sections_url: root + 'variants/' + idField.value,
        }),
      });

      var json = await response.json();

      if (!response.ok) {
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      if (goToCheckout) {
        window.location.href = root + 'checkout';
        return;
      }

      var settings = (window.themeVariables && window.themeVariables.settings) || {};
      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      var cart = await (await fetch(root + 'cart.js')).json();
      cart.sections = json.sections;

      form.dispatchEvent(
        new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart: cart } })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
      );
    } catch (error) {
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: String(error) } }));
      console.error('[lkl-cart] add with accessories failed', error);
    } finally {
      buttons.forEach(function (button) { button.removeAttribute('aria-busy'); });
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;

      var buyNow = !!(event.submitter && event.submitter.hasAttribute('data-lkl-buy-now'));
      var extras = accessoryItems();
      if (!extras.length && !buyNow) return;

      event.preventDefault();
      event.stopPropagation();
      addProductWithAccessories(form, extras, buyNow);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-lkl-add]');
    if (add) {
      event.preventDefault();
      addAccessory(add);
      return;
    }

    var option = event.target.closest('[data-lkl-select-list] [role="option"]');
    if (option) {
      event.preventDefault();
      chooseOption(option);
      return;
    }

    var trigger = event.target.closest('[data-lkl-select-button]');
    if (trigger) {
      event.preventDefault();
      var select = trigger.closest('[data-lkl-select]');
      if (trigger.getAttribute('aria-expanded') === 'true') closeAllSelects();
      else openSelect(select);
      return;
    }

    if (event.target.closest('[data-lkl-select]')) return;

    closeAllSelects();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllSelects();
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-lkl-select-list]')) return;
      closeAllSelects();
    },
    true
  );

  document.documentElement.addEventListener('cart:change', function () {
    setTimeout(function () {
      initCarousels();
    }, 60);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('country-selector').then(function () {
      initEstimatorSelects();
    });
  }

  window.addEventListener('load', function () {
    initEstimatorSelects();
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-lkl-carousel]').forEach(syncCarousel);
  });
})();
